import { createReducer } from '@reduxjs/toolkit';
import {
	restoreHeartBeatStatusStore,
	getHeartBeatStatus,
	getHeartBeatStatusRejected,
	getHeartBeatStatusResolved,
	pollHeartBeatStatusStop,
	setHeartBeatStatusSyncCount,
} from '@Actions';
import { HeartBeatDetailsStoreState, HeartBeatStatus } from '@Types';

const initialHeartBeatStatus: HeartBeatStatus = {
	status: {
		payload: {
			state: { reported: { state: [] } },
			metadata: { reported: { state: [] } },
		},
	},
	metadata: {},
};

export const initialState: HeartBeatDetailsStoreState = {
	status: 'idle',
	initialized: false,
	heartBeatStatus: initialHeartBeatStatus,
	heartBeatSyncAtTs: 0,
	heartbeatSyncCount: 0,
};

const reducer = createReducer(initialState, builder =>
	builder
		.addCase(getHeartBeatStatus, state => {
			state.initialized = false;
			state.status = 'pending';
			state.heartBeatSyncAtTs = Date.now();
		})
		.addCase(getHeartBeatStatusResolved, (state, { payload }) => {
			state.initialized = true;
			state.status = 'completed';
			state.heartBeatStatus = payload;
			state.heartBeatSyncAtTs = Date.now();
			state.heartbeatSyncCount++;
		})
		.addCase(getHeartBeatStatusRejected, state => {
			state.initialized = true;
			state.status = 'rejected';
			state.heartBeatStatus = initialHeartBeatStatus;
			state.heartBeatSyncAtTs = Date.now();
		})
		.addCase(pollHeartBeatStatusStop, state => {
			state.initialized = true;
			state.status = 'idle';
		})
		.addCase(setHeartBeatStatusSyncCount, (state, action) => {
			state.heartbeatSyncCount = action.payload;
		})
		.addCase(restoreHeartBeatStatusStore, () => initialState),
);

export default reducer;
